import React, { useState } from "react";
import { Space, Select, Input, DatePicker } from "antd";

import { ISSUE_CATEGORIES, ISSUE_STATUSES } from "../../constants/issue";
import { SERVICE_PROVIDER_DETAILS } from "../../constants/serviceProviders";

const SupportTicketFilters = ({
  filters,
  onFiltersChange,
  assignees,
  isUserDetails = false,
}) => {
  const [searchField, setSearchField] = useState("trackingNo");

  const searchBy = (
    <Select
      defaultValue="trackingNo"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="ticketId">Ticket ID</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      {!isUserDetails && (
        <div>
          <Input.Search
            addonBefore={searchBy}
            placeholder="Search"
            onSearch={(term) =>
              onFiltersChange({ ...filters, search: term, searchField })
            }
          />
        </div>
      )}

      <div>
        Submitted Date :{" "}
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={(dates) =>
            dates
              ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                })
          }
        />
      </div>

      <div>
        Category :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 250 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, category: value })}
          mode="multiple"
        >
          {Object.values(ISSUE_CATEGORIES).map((category) => (
            <Select.Option value={category.key}>{category.key}</Select.Option>
          ))}
        </Select>
      </div>

      <div>
        Status :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 250 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, status: value })}
          mode="multiple"
        >
          {ISSUE_STATUSES.map((status) => (
            <Select.Option value={status.key}>{status.name}</Select.Option>
          ))}
        </Select>
      </div>

      <div>
        Sort By :{` `}
        <Select
          defaultValue={"updatedAt"}
          style={{ width: 250 }}
          onChange={(value) => onFiltersChange({ ...filters, sort: value })}
        >
          <Select.Option value="createdAt">Submitted Date</Select.Option>
          <Select.Option value="updatedAt">Last Updated Date</Select.Option>
        </Select>
      </div>

      <div>
        Assignee :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 250 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, assigneeId: value })
          }
          mode="multiple"
        >
          {assignees.map((assignee) => (
            <Select.Option key={assignee.id} value={assignee.id}>
              {assignee.username}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div>
        Courier :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 250 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, serviceProvider: value })
          }
          mode="multiple"
        >
          {SERVICE_PROVIDER_DETAILS.map((sp) => (
            <Select.Option key={sp.key} value={sp.key}>
              {sp.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div>
        Latest Comment :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 250 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, lastCommentedBy: value })}
        >
          <Select.Option value="admin">Admin</Select.Option>
          <Select.Option value="user">User</Select.Option>
          <Select.Option value="none">None</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default SupportTicketFilters;
